<script setup lang="ts">
import type { Content } from "@prismicio/client";

const props = defineProps(getSliceComponentProps<Content.KeyOptionsGridSlice>());

const desktopCols = computed(() => {
  const n = props.slice.primary.options?.length || 0
  if (n <= 2) return n
  if (n % 4 === 0) return 4
  if (n % 3 === 0) return 3
  return n % 4 > n % 3 ? 4 : 3
})

const imageSizes = computed(() => {
  switch (desktopCols.value) {
    case 4: return '(min-width: 1024px) 25vw, (min-width: 768px) 50vw, 100vw'
    case 3: return '(min-width: 768px) 33vw, 100vw'
    case 2: return '(min-width: 768px) 50vw, 100vw'
    default: return '100vw'
  }
})
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-bounded','pa-kog', 'pa-kog--' + slice.variation]"
  >
    <div class="pa-container">
      <div class="pa-kog__header">
        <div class="pa-kog__title">
          <PrismicRichText :field="slice.primary.title" />
        </div>
        <div class="pa-kog__intro">
          <PrismicRichText :field="slice.primary.intro_text" />
        </div>
      </div>

      <div :class="['pa-kog__grid', `pa-kog__grid--cols-${desktopCols}`]">
        <div
            v-for="(item, index) in slice.primary.options"
            :key="index"
            class="pa-kog__card"
        >
          <PrismicImage
              v-if="item.image?.url"
              :field="item.image"
              :widths="[400, 600, 800, 1200]"
              :sizes="imageSizes"
              :imgix-params="{ ar: '4:3', fit: 'crop', auto: 'format,compress' }"
              class="pa-kog__card-image"
          />
          <div class="pa-kog__card-body">
            <div class="pa-kog__card-heading">
              <PrismicRichText :field="item.heading" />
            </div>
            <div class="pa-kog__card-description">
              <PrismicRichText :field="item.description" />
            </div>
            <TrackedPrismicLink
                v-if="item.primary_link && ('id' in item.primary_link || 'url' in item.primary_link)"
                :field="item.primary_link"
                :track="item.link_track_event"
                class="pa-kog__card-link"
            >
              {{ item.primary_link.text || "Meer info" }}
              <span aria-hidden="true">&rarr;</span>
            </TrackedPrismicLink>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
